"use client";

import { useEffect } from "react";
import { useLang } from "@/contexts/language-context";
import AppStoreBadges, {
  APP_STORE_URL,
  PLAY_STORE_URL,
} from "@/components/marketing/AppStoreBadges";

export default function AppLandingClient() {
  const { t } = useLang();

  // En un dispositivo móvil la página ES el redirect (su uso principal es el
  // QR impreso y el link que dicta soporte por teléfono). En desktop se queda
  // mostrando los dos badges. El shell nativo nunca llega aquí: NativeShellGate
  // (layout de marketing) lo devuelve a /tablet antes.
  useEffect(() => {
    const ua = navigator.userAgent;
    const isAndroid = /android/i.test(ua);
    // iPadOS 13+ se reporta como Macintosh; el touch lo delata.
    const isApple =
      /iPad|iPhone|iPod/.test(ua) ||
      (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
    if (isAndroid) {
      window.location.replace(PLAY_STORE_URL);
    } else if (isApple) {
      window.location.replace(APP_STORE_URL);
    }
  }, []);

  return (
    <section className="min-h-[70vh] flex items-center justify-center px-6 pt-32 pb-24">
      <div className="max-w-[640px] mx-auto text-center">
        <div className="text-[11px] font-bold tracking-widest uppercase text-redy-orange mb-4">
          {t("Redy POS — the app", "Redy POS — la app")}
        </div>
        <h1 className="text-4xl md:text-[56px] font-black tracking-tight leading-[1.04] text-redy-charcoal mb-5">
          {t("One app.", "Una app.")}
          <br />
          <span className="text-black/30">
            {t("The whole restaurant.", "Todo el restaurante.")}
          </span>
        </h1>
        <p className="text-[16px] font-medium text-redy-secondary max-w-[480px] mx-auto leading-relaxed mb-10">
          {t(
            "POS, kitchen display, self-order kiosk and customer display — the same app plays every role. Install it on your iPad, Android tablet or phone and pair it with your account in seconds.",
            "POS, pantalla de cocina, kiosko de autoservicio y pantalla del cliente — la misma app juega todos los roles. Instálala en tu iPad, tablet Android o teléfono y emparéjala con tu cuenta en segundos."
          )}
        </p>
        <AppStoreBadges className="justify-center" height={52} />
        <p className="text-[12.5px] font-medium text-redy-secondary/70 mt-8">
          {t(
            "Free download · Works with your Redy account · iPad 7+, Android 10+",
            "Descarga gratis · Funciona con tu cuenta Redy · iPad 7+, Android 10+"
          )}
        </p>
      </div>
    </section>
  );
}
